export default __webpack_public_path__ + "07ebb5d9dc778fd138715617cd9404d3.png";